export class SampleHistoryProcessSteps {
    plateId: string;
    position: string;
    puid: string;
    stepTime: string;
    equipment: any;
    reagents: any[];
    stepAction: string = "";
    batchID:string;
}
